<template>
  <b-modal size="xl"
           v-model="isModalOpen"
           no-close-on-backdrop
           hide-header
           hide-footer>
    <div class="modal-header">
      <h5 v-if="siteValue.detail_id" class="modal-title">외부 사이트 상세</h5>
      <h5 v-if="!siteValue.detail_id" class="modal-title">크롤링 정보 추가</h5>
      <button type="button" class="close" @click="closeModal">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <!-- 모달 내용 -->
      <b-row>
        <b-col>
          <table class="table table-bordered oddBackground">
            <tbody>
            <tr>
              <td colspan="4" class="black-border-top">사이트 기본 정보</td>
            </tr>
            <tr>
              <td style="width: 15%;">사이트 Detail ID</td>
              <td style="width: 35%;" class="tl"> {{ siteValue.detail_id ? siteValue.detail_id:'자동 추가' }}</td>
              <td style="width: 15%;">사이트 ID</td>
              <td style="width: 35%;" class="tl">{{ siteValue.site_id }}</td>
            </tr>
            <tr>
              <td style="width: 15%;">사이트 메인 URL</td>
              <td colspan="3" class="tl">
                <b-form-input type="text"
                              v-model="siteValue.main_url"
                              :class="{'is-invalid': errors.has('sub_title')}"
                />
              </td>
            </tr>
            <tr>
              <td style="width: 15%;">사이트 SUB URL</td>
              <td colspan="3" class="tl">
                <b-form-input type="text"
                              v-model="siteValue.sub_url"
                />
              </td>
            </tr>
            <tr>
              <td style="width: 15%;">DEPTH</td>
              <td style="width: 35%;" class="tl">
                <b-form-input type="text"
                              v-model="siteValue.depth_flag"
                />
              </td>
              <td style="width: 15%;">METHOD TYPE (GET/POST)</td>
              <td style="width: 35%;" class="tl">
                <b-form-input type="text"
                              v-model="siteValue.method_type"
                />
              </td>
            </tr>
            <tr>
              <td style="width: 15%;">MENU NAME</td>
              <td style="width: 35%;" class="tl">
                <b-form-input type="text"
                              v-model="siteValue.menu_name"
                />
              </td>
              <td style="width: 15%;">크롤러 타입</td>
              <td style="width: 35%;" class="tl">
                <b-form-input type="text"
                              v-model="siteValue.crawler_type"
                />
              </td>
            </tr>

            <tr>
              <td colspan="4" class="black-border-top">데이터 수집 CSS Selector 정의</td>
            </tr>
            <!-- 해당값은 depth1 에서만 필요함  -->
            <tr v-if="siteValue.depth_flag !== 2">
              <td style="width: 15%;">사이트 페이징 정보</td>
              <td style="width: 35%;" class="tl">
                <b-form-input type="text"
                              v-model="siteValue.paging_param_name"
                />
              </td>
              <td style="width: 15%;">글 목록 LIST</td>
              <td style="width: 35%;" class="tl">
                <b-form-input type="text"
                              v-model="siteValue.list_selector"
                />
              </td>
            </tr>
            <!-- depth1일 경우 글 목록 LIST로 선택한 값에서 CSS SELECTOR 정의해야 함 -->
            <tr>
              <td style="width: 15%;">TITLE</td>
              <td style="width: 35%;" class="tl">
                <b-form-input type="text"
                              v-model="siteValue.title_selector"
                />
              </td>
              <td style="width: 15%;">AUTHOR</td>
              <td style="width: 35%;" class="tl">
                <b-form-input type="text"
                              v-model="siteValue.author_selector"
                />
              </td>
            </tr>
            <tr>
              <td style="width: 15%;">DESCRIPTION</td>
              <td style="width: 35%;" class="tl">
                <b-form-input type="text"
                              v-model="siteValue.description_selector"
                />
              </td>
              <td style="width: 15%;">POSTING DATE</td>
              <td style="width: 35%;" class="tl">
                <b-form-input type="text"
                              v-model="siteValue.posting_date_selector"
                />
              </td>
            </tr>
            <tr>
              <td style="width: 15%;">HASHTAG LIST</td>
              <td style="width: 35%;" class="tl">
                <b-form-input type="text"
                              v-model="siteValue.hash_tag_selector"
                />
              </td>
              <td style="width: 15%;">IMAGE URL</td>
              <td style="width: 35%;" class="tl">
                <b-form-input type="text"
                              v-model="siteValue.img_url_selector"
                />
              </td>
            </tr>
            <tr>
              <td style="width: 15%;">DEPTH2 LINK (글 상세 LINK URL)</td>
              <td style="width: 35%;" class="tl">
                <b-form-input type="text"
                              v-model="siteValue.link_selector"
                />
              </td>
            </tr>

            <tr>
              <td colspan="4" class="black-border-top">사이트 기타 정보</td>
            </tr>

            <tr>
              <td style="width: 15%;">PARAM1</td>
              <td style="width: 35%;" class="tl">
                <b-form-input type="text"
                              v-model="siteValue.param1"
                />
              </td>
              <td style="width: 15%;">PARAM2</td>
              <td style="width: 35%;" class="tl">
                <b-form-input type="text"
                              v-model="siteValue.param2"
                />
              </td>
            </tr>

            </tbody>
          </table>
        </b-col>
      </b-row>
    </div>
    <div class="modal-footer">
      <button class="btn btn-primary" v-if="this.siteValue.detail_id" @click="modifyExtSiteDetail('update')">수정</button>
      <button class="btn btn-danger" v-if="this.siteValue.detail_id" @click="modifyExtSiteDetail('delete')">삭제</button>
      <button class="btn btn-primary" v-if="!this.siteValue.detail_id" @click="modifyExtSiteDetail('insert')">추가</button>
      <button class="btn btn-secondary" @click="closeModal">취소</button>
    </div>
  </b-modal>
</template>
<script>
import swal from 'sweetalert2'
import { EventBus } from "../../../event-bus";

export default {
  name: "extSiteDetailModal",
  props: {
    formModal: {
      type: Boolean,
    },
    selectedSiteDetail: {
      type: Object,
    }
  },
  data() {
    return {
      isModalOpen: false,
      siteValue:{
        detail_id:'',
        site_id:'',
        main_url:'',
        sub_url:'',
        list_selector:'',
        title_selector:'',
        author_selector:'',
        description_selector:'',
        posting_date_selector:'',
        hash_tag_selector:'',
        img_url_selector:'',
        link_selector:'',
        menu_name:'',
        paging_param_name:'',
        param1:'',
        param2:'',
        depth_flag:'',
        use_yn:null,
        method_type: '',
        crawler_type:''
      }

    }
  },

  methods: {
    errorModal(title){
      swal.fire({
        type: 'warning',
        title: title,
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    },
    validateInput(){
      if(this.siteValue.main_url === null || this.siteValue.main_url === ''){
        this.errorModal("사이트 메인 URL 값은 필수입니다.")
      }
      else if(this.siteValue.sub_url === null || this.siteValue.sub_url === ''){
        this.errorModal("사이트 SUB URL 값은 필수입니다.")
      }
      else if(this.siteValue.depth_flag === null || this.siteValue.depth_flag === ''){
        this.errorModal("DEPTH 값은 필수입니다.")
      }
      else if(this.siteValue.crawler_type === null || this.siteValue.crawler_type === ''){
        this.errorModal("크롤러 타입 값은 필수입니다.")
      }
      else return true;
    },
    //extSiteDetail 관련 추가/수정/삭제 api 호출
    modifyExtSiteDetail(method) {
      let url = '';
      let successTitle = '';

      if(method === 'insert'){
        if(this.validateInput()){
          url = '/api/insert/insertExtSiteDetail?access_token=';
          successTitle = '등록 되었습니다.'
          this.extSiteDetailApi(url, successTitle)
        }
      }
      else if(method === 'update'){
        if(this.validateInput()) {
          url = '/api/update/updateExtSiteDetail?access_token=';
          successTitle = '수정 되었습니다.'
          this.extSiteDetailApi(url, successTitle)
        }
      }
      else if(method === 'delete'){
        url = '/api/delete/deleteExtSiteDetail?access_token=';
        successTitle = '삭제 되었습니다.'
        swal.fire({
          title: '',
          text: "해당 정보를 삭제하시겠습니까?",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'OK'
        }).then((swalResult) => {
          if(swalResult.value){
            this.extSiteDetailApi(url, successTitle)
          }
        });
      }
    },
    extSiteDetailApi(url, successTitle){
      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(this.siteValue));
      var data = new FormData();
      data.append('objs', param);

      this.$http.post(url+token, data, null)
        .then((result) => {
          const { data } = result;

          if(data === 'ok'){
            swal.fire({
              type: 'success',
              title: successTitle,
              showConfirmButton: true,
              timer: 1500
            })
            .then(() =>{
              this.closeModal()
              //크롤링 세부정보 다시 조회
              EventBus.$emit('refreshExtSiteDetail')
            })
          }
          else{
            swal.fire({
              type: 'error',
              title: '오류가 발생하였습니다.',
              showConfirmButton: false,
              timer: 1500
            })
          }
        })
        .catch((result) => {
          swal.fire({
            type: 'error',
            title: '저장 중 오류가 발생하였습니다.',
            text: result.response.status+' error',
            showConfirmButton: false,
            timer: 1500
          })
        });
    },

    closeModal(){
      EventBus.$emit('callExtSiteDetailCloseModal');
    },

  },
  watch: {
    formModal: function (value, oldValue) {
      this.isModalOpen=  this.formModal;
    },
    selectedSiteDetail: function (value, oldValue) {
      this.siteValue = {}
      this.siteValue.detail_id = value.detail_id
      this.siteValue.site_id = value.site_id
      this.siteValue.main_url = value.main_url
      this.siteValue.sub_url = value.sub_url
      this.siteValue.list_selector = value.list_selector
      this.siteValue.title_selector = value.title_selector
      this.siteValue.author_selector = value.author_selector
      this.siteValue.description_selector = value.description_selector
      this.siteValue.posting_date_selector = value.posting_date_selector
      this.siteValue.hash_tag_selector = value.hash_tag_selector
      this.siteValue.img_url_selector = value.img_url_selector
      this.siteValue.link_selector = value.link_selector
      this.siteValue.menu_name = value.menu_name
      this.siteValue.paging_param_name = value.paging_param_name
      this.siteValue.param1 = value.param1
      this.siteValue.param2 = value.param2
      this.siteValue.depth_flag = value.depth_flag
      this.siteValue.use_yn = value.use_yn
      this.siteValue.method_type = value.method_type
      this.siteValue.crawler_type = value.crawler_type
    }
  },
}
</script>
<style lang="css" scoped>
.oddBackground td:nth-child(odd) {
  background:#dcdcdc;
  font-weight: 600;
  text-align: center;
}
.tl {
  text-align: left;
}
.black-border-top{
  border-top: 2px solid black;
}
.btn-secondary{
  color:white;
}
.btn-secondary:active{
  color:white !important;
}
</style>



// WEBPACK FOOTER //
// src/views/contents/extSite/component/ExtSiteDetailModal.vue